import { useTheme } from "@emotion/react";
import { Box, Paper, Typography } from "@mui/material";
import useStyles from "./styles";
import {
  TimelineOutlined,
  TrendingDownOutlined,
  TrendingFlatOutlined,
  TrendingUpOutlined,
} from "@mui/icons-material";

export default function CardCountPrefixes({
  title,
  icon,
  value,
  iconColor,
  valueColor,
  titleColor,
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const icons = {
    1: TrendingUpOutlined,
    2: TrendingFlatOutlined,
    3: TrendingDownOutlined,
    4: TimelineOutlined,
  };

  const IconComponent = icons[icon];

  return (
    <Paper sx={styles.paper} elevation={0}>
      <Box sx={styles.box}>
        {IconComponent && (
          <IconComponent
            sx={{
              fontSize: 16,
              color: iconColor,
            }}
          />
        )}
        <Typography color={titleColor} fontSize={"12px"}>
          {title}
        </Typography>
      </Box>
      <Typography sx={{ color: valueColor }}>{value}</Typography>
    </Paper>
  );
}
